import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from './I18nContext';
import { getLocaleFromPathname } from './localeRouting';

export function LocaleRouteSync() {
  const location = useLocation();
  const { locale, setLocale } = useI18n();

  useEffect(() => {
    const fromPath = getLocaleFromPathname(location.pathname);
    if (fromPath !== locale) {
      setLocale(fromPath);
    }
  }, [location.pathname, locale, setLocale]);

  return null;
}
